module.exports = __webpack_public_path__ + "img/ea3c552.png";